module.exports = __webpack_public_path__ + "static/media/  (18).d5fae418.jpg";